module.exports = __webpack_public_path__ + "assets/img/diploma-150px.ffc5b390.png";